export const ReservationsStyles = {
  ReservationsNavBtn: {
    borderRadius: "0px",
  },
};
